import { render, staticRenderFns } from "./admin-template.vue?vue&type=template&id=7197f7eb&scoped=true&"
import script from "./admin-template.vue?vue&type=script&lang=js&"
export * from "./admin-template.vue?vue&type=script&lang=js&"
import style0 from "./admin-template.vue?vue&type=style&index=0&id=7197f7eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7197f7eb",
  null
  
)

export default component.exports